import { z } from "zod";

export const heatpumpCreateBrandDtoSchema = z.object({
  name: z.string().min(1),
});

export type THeatpumpCreateBrandDto = z.infer<typeof heatpumpCreateBrandDtoSchema>;
